import "./SessionWrapper.scss";

import { useEffect, useRef } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";

import { ArrowBreadcrumb } from "../../../components/icons";
import { LoadingOverlay } from "../../../components/LoadingOverlay/LoadingOverlay";
import { PageTitle } from "../../../components/PageTitle";
import { useMentorById } from "../../../hooks/reactQueryHooks/useMentors";
import type { SessionPageRef } from "./SessionPage";
import { SessionPage } from "./SessionPage";

export function SessionWrapper() {
  const sessionPageRef = useRef<SessionPageRef>(null);
  const { mentorId } = useParams();
  const navigate = useNavigate();
  const {
    data: mentorData,
    isLoading,
    isFetching,
  } = useMentorById(mentorId ?? "");

  useEffect(() => {
    const currentPageRef = sessionPageRef.current;
    window.addEventListener("beforeunload", () => {
      currentPageRef?.closeConnection?.();
    });
    return () => {
      currentPageRef?.closeConnection?.();
    };
  }, []);

  if (!mentorData && !isLoading) {
    navigate("/error/404");
    return null;
  }

  if (isFetching || isLoading) {
    return (
      <div className="spinner-container">
        <LoadingOverlay />
      </div>
    );
  }

  return (
    <div className="session-wrapper">
      <div className="d-flex align-items-center">
        <Link to="/mentors" className="me-3">
          <ArrowBreadcrumb className="svg-icon" />
        </Link>
        <div className="d-flex align-items-center no-breadcrumbs">
          <div className="app-toolbar app-content-header-toolbar py-6">
            <div className="app-container d-flex flex-stack container-fluid">
              <div className="page-title d-flex flex-wrap me-3 flex-column justify-content-center">
                <h1 className="page-heading text-dark fw-bold fs-1 my-0 flex-column justify-content-center two-lines-text my-0 mb-2">
                  {mentorData.firstName + " " + mentorData.lastName}
                </h1>
                <div className="breadcrumb fw-semibold fs-7">
                  <span className="text-muted">{mentorData.headline}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <SessionPage mentor={mentorData} ref={sessionPageRef} />
    </div>
  );
}
